<!--
    描述：待开发页面
    时间：2020-05-15
    Created by ws
-->
<template>
    <div class="developing-main">
        <div class="text-info">
            页面开发中，请耐心等待......
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped lang="less">
.developing-main {
    font-size: 30px;
    text-align: center;

    .text-info {
        padding-top: 20%;
    }
}
</style>
